import { useState } from "react";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import Header from "../components/header";
import AdminTabCronjobs from "./adminTabCronjobs";
import AdminTabAiModels from "./adminTabAiModels";
import AdminTabTrafficLight from "./adminTabTrafficLight";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
}

const Admin = () => {
  const [value, setValue] = useState(() => {
    const storedTab = sessionStorage.getItem("tabAdmin");
    return storedTab ? JSON.parse(storedTab) : 0;
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("tabAdmin", JSON.stringify(newValue));
  };

  return (
    <Box id="adminMainBox" m="10px" width="75%" height="100%">
      <Stack direction="row" display="flex">
        <Header title="ADMIN SETUP" subtitle="System-Konfiguration" />
      </Stack>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          sx={{
            "& .MuiTab-root": {
              minWidth: 120,
            },
          }}
        >
          <Tab label="Cron Jobs" id="tab-0" />
          <Tab label="AI Modelle & Provider" id="tab-1" />
          <Tab label="Ampel-Kalibrierung" id="tab-2" />
        </Tabs>
        <TabPanel value={value} index={0}>
          <AdminTabCronjobs />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AdminTabAiModels />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AdminTabTrafficLight />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default Admin;
